import { useState, useEffect, useCallback } from 'react'
import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type KeywordType = {
    submittedTypeID: string
    recID: string | null
}

export type ConsiderationDataListType = {
    approveStatusID: number
    name: Translation
    order: number
}

type Translation = {
    th: string
    en: string
}

export const useSearchSettingConsideration = () => {
    const [dataList, setDataList] = useState<ConsiderationDataListType[]>([])

    const callApi = useCallApi()

    const searchSettingConsideration = useCallback(async (values?: KeywordType) => {
        const url = new URL(umServiceURL.getSearchSettingConsideration)
        url.searchParams.set('recID', values?.recID || '1')
        url.searchParams.set('submittedTypeID', values?.submittedTypeID?.toString() || '1')

        const { data } = await callApi.axiosGet({
            url,
        })

        setDataList(data)
    }, [])

    useEffect(() => {
        searchSettingConsideration()
    }, [searchSettingConsideration])

    return {
        dataList,
        setDataList,
        searchSettingConsideration,
    }
}
